import MuiSelect from '@mui/material/Select';
import MuiMenuItem from '@mui/material/MenuItem';
import { ComponentProps } from 'react';

export const Select = (props: ComponentProps<typeof MuiSelect>) => {
  return <MuiSelect size="small" color="primary" {...props} />;
};

export const MenuItem = MuiMenuItem;
